import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {cloudLight} from '/theme/color/on.color';
import {getFontFamily} from '/util/text.util';

export const styles = StyleSheet.create({
  base: {},
  header: {
    paddingVertical: indent,
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  // @ts-expect-error TS(2322): Type '{ fontFamily: string; fontWeight: string | u... Remove this comment to see the full error message
  headerText: {
    ...getFontFamily('bold'),
  },
  order: {
    paddingVertical: indent * 0.8,
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  orderLine1: {
    flex: 1,
    flexDirection: 'row',
  },
  orderDate: {
    flex: 1,
  },
  orderAmount: {
    flex: 0,
  },
  // @ts-expect-error TS(2322): Type '{ fontFamily: string; fontWeight: string | u... Remove this comment to see the full error message
  orderAmountEmptyText: {
    ...getFontFamily('bold'),
  },
  orderLine2: {
    marginTop: indent * 0.2,
  },
});
